import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=e6082670&scoped=true&"
import script from "./SignUpPage.vue?vue&type=script&lang=ts&"
export * from "./SignUpPage.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=e6082670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6082670",
  null
  
)

export default component.exports